module.exports = __webpack_public_path__ + "img/tea_processing_icon.acd74a65.png";